module.exports = __webpack_public_path__ + "img/32@2x.333200cc.png";